<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-block">
        <span class="item-icon">
          <i class="fab fa-elementor"></i>
        </span>
        {{selectedDevice.title}}
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="slVueTree"
          :allowMultiselect="false"
          @select="nodeSelected"
          @drop="nodeDropped"
          @toggle="nodeToggled"
        >
          <template slot="title" slot-scope="{ node }">
            <span class="item-icon">
              <i class="fab fa-elementor"></i>
            </span>
            {{ node.title }}
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="draginfo">{{selectedDevice.title}}</template>
        </sl-vue-tree>
      </div>
    </drop-down>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import SlVueTree from "sl-vue-tree";
import snackBar from "@/components/SnackBar";

import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import axios from "axios";

export default {
  components: {
    "sl-vue-tree": SlVueTree,
    snackBar
  },

  data() {
    return {
      selectedDevice: {
        title: "Select meter",
        ID_meter: 0
      },
      nodes: [],
      treeFind: false
    };
  },

  computed: {
    getSelectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  watch: {
    getSelectedDevice() {
      this.getMetersList();
    }
  },

  created() {
    this.getMetersList();
  },

  methods: {
    iterateOverTree(parent) {
      if (parent) {
        parent.forEach(meter => {
          if (meter.children) {
            this.iterateOverTree(meter.children);
          } else {
            if (meter.isLeaf) {
              if (!this.treeFind) {
                this.selectedDevice = {
                  title: meter.title,
                  ID_meter: meter.data.ID_meter
                };

                this.$emit("on-selected", this.selectedDevice);
                this.treeFind = true;
              }
            }
          }
        });
      }
    },

    setDefaultSelected() {
      if (this.nodes.length === 0) {
        this.selectedDevice = {
          title: "Select meter",
          ID_meter: 0
        };
        this.$emit("on-selected", this.selectedDevice);
      } else {
        this.treeFind = false;
        this.iterateOverTree(this.nodes);
      }
    },

    getMetersList() {
      this.nodes = [];
      this.selectedDevice = {
        title: "Select meter",
        ID_meter: 0
      };

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/meters",
        data: {
          device_token: getSelectedDeviceToken(this.getSelectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach((meter, index) => {
            this.nodes.push({
              title: meter.SNUM + " | " + meter.TYPE,
              isLeaf: true,
              data: {
                ID_meter: meter.ID_meter
              }
            });
          });
          this.setDefaultSelected();
        })
        .catch(error => {
          this.setDefaultSelected();
          if (error.response) {
            if (error.response.data.code === 610) {
              this.metersData = [];
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    nodeSelected(nodes, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      const isNodeLeaf = nodes.map(node => node.isLeaf)[0];

      if (isNodeLeaf === true) {
        const newSelectedDevice = {
          title: nodes.map(node => node.title).join(", "),
          ID_meter: Number(nodes.map(node => node.data.ID_meter).join(", "))
        };
        if (
          JSON.stringify(this.selectedDevice) !==
          JSON.stringify(newSelectedDevice)
        ) {
          this.selectedDevice = newSelectedDevice;
          this.$emit("on-selected", this.selectedDevice);
        }
      }
    },

    nodeDropped(nodes, position, event) {},

    nodeToggled(node, event) {}
  }
};
</script>


<style lang="scss" scoped>
i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.status-icon {
  width: 10px;
  height: auto;
  /*   margin-right: 12px;  */
}
</style>


<style lang="scss">
@import "./src/assets/scss/md/_variables";

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}
</style>

